import { render, staticRenderFns } from "./NewMarkWriting.vue?vue&type=template&id=49bc2535&scoped=true"
import script from "./NewMarkWriting.vue?vue&type=script&lang=js"
export * from "./NewMarkWriting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bc2535",
  null
  
)

export default component.exports